export enum UiListTileLeadingColor {
  Black,
  Gray,
  Blue,
  Yellow,
  Orange,
  Red,
}

export enum UiListTileBackgroundColor {
  Pink,
  Orange,
}

export enum UiListSectionType {
  Warnings = 'i3H4C4ZdrYAfFoCtkaeiC',
  OutagesAndClosures = 'gDfl0cOHihK9_UA8AcJJT',
  Incidents = 'tE7WsidrEZnRAqb0Iw4bc',
  NaturalHazards = 'qdbLtnywXWkG2to5yLPI8',
  Centres = 'IdaFPyJzD-KUpjlTXGsao',
}

// TODO: Strongly type this (IncidentEntity['incidentType']) instead of using string
export const naturalHazardTypes = ['Storm', 'Tsunami', 'Cyclone', 'Earthquake', 'Flood', 'Coastal Hazard', 'Damaging Winds', 'Storm Surge'];
